import { css, type Styles } from '@repo/pandacss/styled-system/css';

export const disclosureTooltipPopoverBase = {
  backgroundColor: 'neutral.white',
  border: '[1px solid token(colors.neutral.lighter)]',
  borderRadius: '[none]',
  boxShadow:
    '[0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)]',
  padding: '4',
  maxWidth: '[340px]',
  textAlign: 'left',
  color: 'neutral.black',
  fontWeight: 'normal',
  lineHeight: 'xxxxxl',
  outline: 'none',
  '&[data-side="top"]': {
    marginBottom: '2',
  },
  '&[data-side="bottom"]': {
    marginTop: '2',
  },
  '&[data-side="left"]': {
    marginRight: '2',
  },
  '&[data-side="right"]': {
    marginLeft: '2',
  },
} satisfies Styles;

export const summaryTableRowCdApyDriverTooltipClassName = css(disclosureTooltipPopoverBase, {
  lineHeight: {
    base: 'xxxl',
    md: 'sm',
  },
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
});

export const summaryTableHeadingTooltipClassName = css(disclosureTooltipPopoverBase, {
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
  marginTop: '4',
});

export const summaryTableDetailsCellTooltipClassName = css(disclosureTooltipPopoverBase, {
  fontSize: { base: 'sm', md: '[11px]' },
});

export const summaryTableDriverCellTooltipClassName = css(disclosureTooltipPopoverBase, {
  fontSize: { base: 'sm', md: '[11px]' },
  lineHeight: 'xxxxxl',
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
});

export const numericLayoutTooltipClassName = css(disclosureTooltipPopoverBase, {
  maxWidth: '[265px]',
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
  lineHeight: '[14px]',
});

export const singleStarLayoutTooltipClassName = css(disclosureTooltipPopoverBase, {
  maxWidth: '[265px]',
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
  lineHeight: 'xs',
});

export const productCardDriverTooltipClassName = css(disclosureTooltipPopoverBase, {
  lineHeight: {
    base: '[1.57]',
    md: 'md',
  },
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
});

export const productCardCdApysDriverTooltipClassName = css(disclosureTooltipPopoverBase, {
  lineHeight: {
    base: 'xxxl',
    md: 'md',
  },
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
});

export const advertisingDisclosureTooltipClassName = css(disclosureTooltipPopoverBase, {
  overflowWrap: 'break-word',
  maxWidth: {
    base: '[100vw]',
    md: '[min(578px, var(--available-width, calc(100vw - 4px)))]',
  },
});

export const roundupHeaderAdvertisingDisclosureTooltipClassName = css(
  disclosureTooltipPopoverBase,
  {
    overflowWrap: 'break-word',
    paddingInlineStart: '2',
    paddingInlineEnd: '2',
    paddingBlockStart: '3',
    paddingBlockEnd: '3',
    lineHeight: '[15px]',
    maxWidth: {
      base: '[100vw]',
      md: '[min(578px, var(--available-width, calc(100vw - 4px)))]',
    },
  },
);

export const apyDriverTooltipClassName = css(disclosureTooltipPopoverBase, {
  paddingInlineStart: '2',
  paddingInlineEnd: '2',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
  lineHeight: 'sm',
});

export const multiProductBannerHeaderTooltipClassName = css(disclosureTooltipPopoverBase, {
  paddingInlineStart: '4',
  paddingInlineEnd: '4',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
  maxWidth: '[232px]',
  color: 'neutral.darker',
  lineHeight: { base: 'xxxl', md: 'md' },
});

export const multiProductBannerApyDriverTooltipClassName = css(disclosureTooltipPopoverBase, {
  maxWidth: '[275px]',
  paddingInlineStart: '4',
  paddingInlineEnd: '4',
  paddingBlockStart: '2',
  paddingBlockEnd: '2',
  lineHeight: { base: 'xxxl', md: 'md' },
});

export const disclosureTooltipPopoverClassName = css(disclosureTooltipPopoverBase);
export const cdRatesProductCardRatingTooltipClassName = css(disclosureTooltipPopoverBase, {
  fontSize: 'sm',
  lineHeight: {
    base: 'xxxxxl',
    md: 'normal',
  },
  overflowWrap: 'break-word',
  paddingInlineStart: '6',
  paddingInlineEnd: '6',
  paddingBlockStart: '3',
  paddingBlockEnd: '3',
});
